import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FILTER_DIALOG_WRAPPER_PANEL_CLASS } from './filter-dialog-wrapper-panel-class';

export class FilterDialogWrapperBase {
  protected readonly dialog: MatDialog = inject(MatDialog);

  protected readonly panelClass: string = FILTER_DIALOG_WRAPPER_PANEL_CLASS;
}
